module.exports = __webpack_public_path__ + "img/ring_r_skip_1_0@2x.9a6fac3b.png";